import React from 'react';
import { useEffect } from 'react';
import { api } from 'services';
import { useState } from 'react';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, Row, Col, Modal, Button, Spinner } from 'react-bootstrap';
import { MDBBtn } from 'mdbreact';
import styles from './style.module.scss';
import ListingFilesDataBase from 'components/ListingFilesDataBase';
import ActionAttachingModal from './ActionAttachingModal';
import Can from 'components/Can';
import { DashboardOutlined, DeleteOutline } from '@material-ui/icons';

function S3Explorer(props) {
  const location = useLocation();
  const { t } = useTranslation();
  const match = useRouteMatch();
  const { pathname } = location;
  const { year: queryYear, month: queryMonth } = match.params;
  const [year, setYear] = useState(match.params.year);
  const [month, setMonth] = useState(match.params.month);
  
  const defaultFilters = { __search: '', per_page: pathname.includes('files')?10:3000, page: 1, __year:year, __month:month, __modal:pathname.includes('files')?'':true };

  const [filters, setFilters] = useState(defaultFilters);
  const [files, setFiles] = useState([]);
  const [months, setMonths] = useState([]);
  const [years, setYears] = useState([]);
  const [modal, setModal] = useState(false);
  const [currentFile, setCurrentFile] = useState({});
  const [modalActions, setModalActions] = useState(false);
  const [status, setStatus] = useState(0);
  const [pagination, setPagination] = useState(null);

  const [load, setLoad] = useState(true);
  
  var monthsListName = new Array();
  monthsListName[0] = t('months:jan');
  monthsListName[1] = t('months:fev');
  monthsListName[2] = t('months:mar');
  monthsListName[3] = t('months:abr');
  monthsListName[4] = t('months:mai');
  monthsListName[5] = t('months:jun');
  monthsListName[6] = t('months:jul');
  monthsListName[7] = t('months:ago');
  monthsListName[8] = t('months:set');
  monthsListName[9] = t('months:out');
  monthsListName[10] = t('months:nov');
  monthsListName[11] = t('months:dez');
  useEffect(() => {
    setLoad(true);
    api
      .get('invoice',{ params: { ...filters } })
      .then((res) => {
        if(!filters.__year && !filters.__month){
          setYears(res.data.map(a=>a.year));
        } else if(!filters.__month){
          setYears([]);
          setMonths(res.data.sort((a, b) => a.month - b.month).map(a=>{return {id:a.month,name:monthsListName[a.month-1]};}));
        } else {
          setMonths([]);
          function getType(entity_type){
            if(entity_type == "App\\Models\\ExpenseDescription"){
              return 'action';
            } else if(entity_type == "App\\Models\\EventExpenseDescription"){
              return 'event';
            }
            return null;
          }
          setPagination(res.data.pagination);
          setFiles(res.data.data);
        }
        setLoad(false);
      });
  }, [filters]);

  const exitModal = () => {
    setModal(false);
    setMonth('');
    setYear('');
  };

  const modalBtn = () => {
    setModal(true);
  };

  const setActiveFile = (file) => {
    setCurrentFile(file);
    props.setData(file);
    setModal(false);
  };

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const renderListYears = (modal=false) => {
    return (
      <div className={styles.cards}>
        {years.sort((a, b) => b - a).map((a,k)=>{
          return <Col className="d-flex flex-column" key={k}>
          {modal?(
            <MDBBtn onClick={() => handleFilterChange({__year:a,__modal:true})}>
              <img src={'/folder.png'} width="55vw" heigth="55vh" />
              <p>{a}</p>
            </MDBBtn>
          ):(
          <Link to={`/files/${a}`}>
            <img src={'/folder.png'} width="55vw" heigth="55vh" />
            <p>{a}</p>
          </Link>
          )}
        </Col>;
        })}
      </div>
    );
  }

  const renderListMonths = (modal=false) => {
    return (
      <div className={styles.cards}>
        {months.sort((a, b) => b - a).map((a,k)=>{
          return <Col>
          {modal?(
            <MDBBtn onClick={() => handleFilterChange({__month:a.id})}>
              <img src={'/folder.png'} width="55vw" heigth="55vh" />
              <p>{a.name}</p>
            </MDBBtn>
          ):(
            <Link to={`/files/${year}/${a.id}`}>
              <img src={'/folder.png'} width="55vw" heigth="55vh" />
              <p>{a.name}</p>
            </Link>
          )}
        </Col>;
        })}
      </div>
    );
  }

  const renderListFiles = (modal=false) => {
    return <ListingFilesDataBase
    files={files}
    setFiles={setActiveFile}
    filters={[]}
    stateFilters={filters}
    setFilters={setFilters}
    handleFilterChange={handleFilterChange}
    attachingModal={() => setModalActions(!modalActions)}
    status={status}
    setStatus={setStatus}
    pagination={pagination}
  />;
  }

  const renderLoad = () => {
    return <Spinner animation="border" style={{ color: '#e05c17' }} role="status" >
      <span className="sr-only">Loading...</span>
    </Spinner>;
    // return <h6>{t('phrase:invoice')}</h6>;
  };

  const renderPath = (modal = false) => {
    if(modal){
      return <Row>
        <Col xs="auto">
          <Link onClick={() => {
            handleFilterChange({__year:'',__month:''});
            setYears([]);
            setMonths([]);
            setFiles([]);
          }}>
            <p>Files</p>
          </Link>
        </Col>
        {filters.__year?<>
        <Col xs="auto" className="p-0"><p>{'>'}</p></Col>
        <Col xs="auto">
          <Link onClick={() => {
            handleFilterChange({__month:''});
            setMonths([]);
            setFiles([]);

          }}>
            <p>{filters.__year}</p>
          </Link>
        </Col>
        </>:''}
        {filters.__month?<>
        <Col xs="auto" className="p-0"><p>{'>'}</p></Col>
        <Col xs="auto">
          <Link onClick={() => {
            // handleFilterChange({__month:''});
          }}>
            <p>{monthsListName[filters.__month-1]}</p>
          </Link>
        </Col>
        </>:''}
      </Row>;
    } 
    return <Row>
      <Col>
        <Link to={`/files/`}>
          <p>Files</p>
        </Link>
      </Col>
      {year?<>
      <Col className="p-0"><p>{'>'}</p></Col>
      <Col>
        <Link to={`/files/${year}`}>
          <p>{year}</p>
        </Link>
      </Col>
      </>:''}
      {month?<>
      <Col className="p-0"><p>{'>'}</p></Col>
      <Col>
        <Link to={`/files/${year}/${month}`}>
          <p>{monthsListName[month-1]}</p>
        </Link>
      </Col>
      </>:''}
    </Row>;
  }

  return (
    <>
      {pathname.includes('files') ? (
        <>
          <Card.Body className="shadow bg-white rounded mb-3">
            <Row className="mb-2">
              {currentFile.name ? (
                <Col>
                  <img src={'/file.png'} width="55vw" heigth="55vh" />
                  <p>{currentFile.name}</p>
                </Col>
              ) : (
                  <Col className="d-flex mt-3 mb-3">
                    <DashboardOutlined className="icon-title" />
                    <h4 className="title-dashboard mt-2">{t('title:nf database')}</h4>
                  </Col>
                )}
            </Row>
            <Row className="mt-2 mb-3 justify-content-between">
              <Can do="createExpenseDescription" on="App">
                <Col>
                  <Button
                    size="sm"
                    className="login-btn mr-1"
                    variant="primary-login"
                    as={Link}
                    to="/files/add-invoice"
                  >
                    <i className="fas fa-plus" /> {t('label:add new')}
                  </Button>
                </Col>
              </Can>
              <Col xs="auto">
              {renderPath()}
              </Col>
            </Row>
            {load?renderLoad():''}
            {years.length>0?renderListYears():''}
            {months.length>0?renderListMonths():''}
            {years.length==0 && months.length==0 && !load?renderListFiles():''}
            
          </Card.Body>
        </>
      ) : (
          <Col>
            <Row className="mt-2 mb-1">
              {!currentFile.name ? (
                <Button
                  variant="dark"
                  alt={t('label: nf link')}
                  size="sm"
                  onClick={modalBtn}
                >
                  <i className="fas fa-link mr-1" /> {t('label:nf link')}
                </Button>
              ) : (
                <>
                  <Col md={9}>
                    <img src={'/file.png'} width="55vw" heigth="55vh" />
                    <p>{currentFile.name}</p>
                  </Col>
                  <Col md={3}>                    
                    <Button 
                      className="float-right"
                      variant="danger" 
                      size="sm"
                      onClick={() => {
                        setCurrentFile({})
                        setYear('');
                        setMonth('');
                        props.setVinculated('exist');
                        props.clearData()
                      }
                    }>
                      Trocar Nota
                    </Button>
                  </Col>
                </>
              )}
            </Row>
            <Modal 
              dialogClassName={years.length==0 && months.length==0 && !load ? "modal-90w" : ""} 
              show={modal} 
              onHide={exitModal}
            >
              <Modal.Header closeButton />
              <Modal.Body>
              {renderPath(true)}
              {load?renderLoad():''}
              {years.length>0?renderListYears(true):''}
              {months.length>0?renderListMonths(true):''}
              {years.length==0 && months.length==0 && !load?renderListFiles(true):''}
              </Modal.Body>
            </Modal>
          </Col>
        )}
    </>
  );
}

export default S3Explorer;
